import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Employee } from '@/types';
    import ContinueButton from '@/components/ContinueButton.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ExportEmployeeChanges',
  props: {
    employee: {}
  },
  setup(__props: any) {

    const props = __props;

    const exportEmployeeChanges = () => {
        document.location.href = route('v2.salary.employee.changes.export', {
            id: props.employee.id,
        });
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContinueButton, { onClick: exportEmployeeChanges }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('forms.export')), 1)
    ]),
    _: 1
  }))
}
}

})